import { useCompleteFragment } from '@eluve/apollo-client';

import { useAppointmentId } from './appointment.context';
import {
  appointmentLlmOutputTemplateFragment,
  latestHumanSOAPNoteFragment,
} from './operations';

// Resolve from the same template that produced the rendered blocks; otherwise
// EHR builds a chart whose chart_parts don't match the synced blocks (FB-406).
export const useExternalTemplateId = () => {
  const appointmentId = useAppointmentId();

  const summaryData = useCompleteFragment({
    fragment: latestHumanSOAPNoteFragment,
    key: { id: appointmentId },
    strict: false,
  });

  const appointmentData = useCompleteFragment({
    fragment: appointmentLlmOutputTemplateFragment,
    key: { id: appointmentId },
    strict: false,
  });

  const humanOutput = summaryData?.humanOutputs?.[0];

  const fromLlmOutput =
    humanOutput?.output?.llm_output?.metadata?.output_template
      ?.external_chart_templates?.[0]?.externalChartTemplateId ?? null;

  const fromManualChartingTemplate =
    humanOutput?.output_template?.llm_output_template
      ?.external_chart_templates?.[0]?.externalChartTemplateId ?? null;

  const fromAppointment =
    appointmentData?.llm_output_template?.external_chart_templates?.[0]
      ?.externalChartTemplateId ?? null;

  return fromLlmOutput ?? fromManualChartingTemplate ?? fromAppointment;
};
